/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Two_KkInputs */

const cs_enum_two_kk = /** @type {(inputs: Enum_Two_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2+kk`)
};

const en_enum_two_kk = /** @type {(inputs: Enum_Two_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2+kk`)
};

/**
* | output |
* | --- |
* | "2+kk" |
*
* @param {Enum_Two_KkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_two_kk = /** @type {((inputs?: Enum_Two_KkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Two_KkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_two_kk(inputs)
	return cs_enum_two_kk(inputs)
});